export default __webpack_public_path__ + "static/media/logo.f856086a.png";